import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row g-3" }
const _hoisted_3 = { class: "col-md-3" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = {
  key: 1,
  class: "kindergartenAllowance-heads-table"
}
const _hoisted_6 = {
  key: 2,
  class: "modal"
}
const _hoisted_7 = { class: "modal-content" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[22] || (_cache[22] = _createElementVNode("h1", null, "Директора ДО", -1)),
    (_ctx.isFetching)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_1, "Загрузка..."))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[13] || (_cache[13] = _createElementVNode("label", {
          for: "regionGroupSelect",
          class: "form-label"
        }, "БИН", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fetchKindergartenHeads(true))),
          class: "form-control",
          id: "username",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchParam.username) = $event))
        }, null, 544), [
          [_vModelText, _ctx.searchParam.username]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[14] || (_cache[14] = _createElementVNode("label", {
          for: "regionGroupSelect",
          class: "form-label"
        }, "ИИН Директорв", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fetchKindergartenHeads(true))),
          class: "form-control",
          id: "username",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchParam.iin) = $event))
        }, null, 544), [
          [_vModelText, _ctx.searchParam.iin]
        ])
      ])
    ]),
    _createVNode(_component_b_pagination, {
      modelValue: _ctx.currentPage,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentPage) = $event)),
      "total-rows": _ctx.pageResponse?.totalElements,
      "per-page": _ctx.searchParam.perPage
    }, null, 8, ["modelValue", "total-rows", "per-page"]),
    _createElementVNode("button", {
      class: "open-modal-btn",
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
    }, "Добавить директора ДО"),
    (_ctx.kindergartenHeads.length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
          _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "ID"),
              _createElementVNode("th", null, "Имя"),
              _createElementVNode("th", null, "Фамилия"),
              _createElementVNode("th", null, "Username"),
              _createElementVNode("th", null, "ИИН"),
              _createElementVNode("th", null, "LMS ID"),
              _createElementVNode("th", null, "БИН ДО"),
              _createElementVNode("th", null, "Название ДО")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kindergartenHeads, (head) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: _ctx.safeUserInfoId(head.userInfo)
              }, [
                _createElementVNode("td", null, _toDisplayString(head.userInfo.id), 1),
                _createElementVNode("td", null, _toDisplayString(head.userInfo.firstName), 1),
                _createElementVNode("td", null, _toDisplayString(head.userInfo.lastName), 1),
                _createElementVNode("td", null, [
                  _createVNode(_component_router_link, {
                    to: `/kindergarten/head/${head.userInfo.id}`,
                    class: "username-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(head.userInfo.username), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("td", null, _toDisplayString(head.userInfo.userAttributes[_ctx.UserAttribute.IIN]), 1),
                _createElementVNode("td", null, _toDisplayString(head.lmsSystem?.lmsId ?? 'N/A'), 1),
                _createElementVNode("td", null, _toDisplayString(head.lmsSystem?.kindergartenDocumentInfo?.bin ?? 'N/A'), 1),
                _createElementVNode("td", null, _toDisplayString(head.lmsSystem?.kindergartenDocumentInfo?.name ?? 'N/A'), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[21] || (_cache[21] = _createElementVNode("h2", null, "Добавить директора ДО", -1)),
            _createElementVNode("form", {
              onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { for: "firstName" }, "Имя:", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "firstName",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.firstName) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.firstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { for: "lastName" }, "Фамилия:", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "lastName",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.lastName) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.lastName]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { for: "username" }, "Имя пользователя:", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "username",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.username) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.username]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { for: "iin" }, "ИИН:", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "iin",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.iin) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.iin]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { for: "lmsId" }, "LMS система:", -1)),
                _createVNode(_component_multiselect, {
                  modelValue: _ctx.selectedLms,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedLms) = $event)),
                  options: _ctx.lmsSystems,
                  label: "lmsId",
                  placeholder: "Выберите LMS систему",
                  searchable: true,
                  "clear-on-select": true,
                  "close-on-select": true,
                  "allow-empty": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "submit-btn",
                disabled: _ctx.isLoading
              }, _toDisplayString(_ctx.isLoading ? 'Создание...' : 'Создать'), 9, _hoisted_13)
            ], 32),
            _createElementVNode("button", {
              class: "close-modal-btn",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, "Закрыть")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}